import {
  clearSessionStorage,
  getSessionStorage,
  passwordValidation,
  removeCookie,
  validateName,
} from "../utils";
import { useEffect, useState } from "preact/hooks";
import { styled } from "@mui/material/styles";
import { IconButton, InputAdornment, TextField, Button } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import BasicModal from "./common/basicModal";
import { Fragment } from "preact";
import useApi from "../hooks/useApi";
import { logoutApi, passwordResetApi } from "../api/controller/accounts";
import { route } from "preact-router";
import ArrowBack from "@mui/icons-material/ArrowBack";

const Container = styled("div")`
  height: 100vh;
  color: #fff;
  background-color: black;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .headerText {
    color: #f7f7f7;
    font-size: 36px;
    font-weight: 700;
    line-height: 48px;
    text-align: center;
  }
  .subText {
    margin: 2.222vh 0px 3.889vh;
    min-width: 250px;
    padding: 0px 10px;
    font-size: 18px;
    color: #f7f7f7;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    text-align: center;
  }
  .inputField {
    height: 56px !important;
    width: 90vw !important;
    margin-top: 3.889vh;
    min-width: 250px;
    max-width: 600px;
  }
  .loginButton {
    width: 90vw;
    max-width: 600px;
    min-width: 250px;
    text-transform: none;
    line-height: 60px;
    margin-top: 30px;
    height: 60px;
    padding: 0px 8px;
    border: 0;
    box-sizing: border-box;
    border-radius: 16px;
    box-shadow: -1px 1px 10px #f0c3f1;
    background-color: #6741d9;
    color: #ffffff;
    font-size: 18px;
    font-weight: 600;
    outline: none;
    font-family: Poppins;
  }
  .loginButton:hover {
    border: #f0c3f1 1px solid;
    background-color: #6741d9;
  }
  .loginButton:disabled {
    background-color: #808080;
    color: #000000;
  }
  .arrowDesign {
    cursor: pointer;
    font-size: 40px;
    padding-top: 10px;
  }
`;

const WhiteBorderTextField = styled(TextField)`
  & .MuiOutlinedInput-root {
    & fieldset {
      border-color: #FFF !important;
      border-radius: 8px;
    },
    &.Mui-focused fieldset {
      border-color: #FFF !important;
    },
  },
`;

function ChangePassword() {
  const [password, setPassword] = useState({ pass: "" });
  const [passwordError, setPasswordError] = useState("");
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [newpassword, setNewpassword] = useState({ pass: "" });
  const [newPasswordError, setNewPasswordError] = useState("");
  const [reEnteredPassword, setReEnteredPassword] = useState({ pass: "" });
  const [reEnteredPasswordError, setReEnteredPasswordError] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showReEnteredPassword, setShowReEnteredPassword] = useState(false);
  const handleClickShowNewPassword = () => setShowNewPassword(!showNewPassword);
  const handleMouseDownNewPassword = () => setShowNewPassword(!showNewPassword);
  const handleClickShowReEnteredPassword = () =>
    setShowReEnteredPassword(!showReEnteredPassword);
  const handleMouseDownReEnteredPassword = () =>
    setShowReEnteredPassword(!showReEnteredPassword);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);
  const handleCloseErrorModal = () => {
    setPasswordError("");
    setOpenErrorModal(false);
  };

  const userLogout = () => {
    logoutApi(logoutRequest.request, {
      host: getSessionStorage("host"),
    });
  };

  const handleCloseSuccessModal = () => {
    setOpenSuccessModal(false);
    userLogout();
  };

  const passwordResetApiRequest = useApi();

  const logoutRequest = useApi();

  const userPasswordChange = () => {
    // setOpenErrorModal(true);
    // setOpenSuccessModal(false);
  };

  const handleResetPassword = () => {
    passwordResetApi(passwordResetApiRequest.request, {
      id: getSessionStorage("host"),
      old_password: password.pass,
      new_password: newpassword.pass,
      confirm_password: reEnteredPassword.pass,
    });
  };

  useEffect(() => {
    if (passwordResetApiRequest.data) {
      setOpenSuccessModal(true);
    }
  }, [passwordResetApiRequest.data]);

  useEffect(() => {
    if (passwordResetApiRequest.error) {
      setPasswordError(passwordResetApiRequest.error);
      setOpenErrorModal(true);
    }
  }, [passwordResetApiRequest.error]);

  useEffect(() => {
    if (
      logoutRequest.data &&
      logoutRequest.data.data &&
      logoutRequest.data.data.logout
    ) {
      console.log("logout");
      removeCookie("user_key", window.location.host, "/");
      removeCookie("token", window.location.host, "/");
      removeCookie("user_id", window.location.host, "/");
      clearSessionStorage();
      route("/sign-in");
    }
  }, [logoutRequest.data]);

  return (
    <Fragment>
      <Container>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            width: "100%",
          }}
        >
          <ArrowBack onClick={() => history.go(-1)} className="arrowDesign" />
        </div>
        <div
          style={{
            width: "100%",
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            paddingBottom: "10px",
          }}
        >
          <div className="headerText">Change Password</div>
          <div className="subText">
            Reset password to restart creating memories.
          </div>
          <WhiteBorderTextField
            className="inputField"
            sx={{
              input: { color: "white", fontFamily: "Poppins" },
            }}
            label=" Old Password"
            InputLabelProps={{
              style: {
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                width: "100%",
                color: "#808080",
              },
            }}
            variant="outlined"
            style={{ width: "100%", fontFamily: "poppins" }}
            type={showPassword ? "text" : "password"}
            value={password.pass}
            onChange={(e) => {
              setPassword({ pass: e.target.value });
              // setPasswordError(e.target.value);
            }}
            // error={!!passwordError}
            // helperText={passwordError && passwordError}
            FormHelperTextProps={{ style: { fontFamily: "poppins" } }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    style={{ color: "white" }}
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <WhiteBorderTextField
            className="inputField"
            sx={{
              input: { color: "white", fontFamily: "Poppins" },
            }}
            label="Enter New Password"
            InputLabelProps={{
              style: {
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                width: "100%",
                color: "#808080",
              },
            }}
            variant="outlined"
            type={showNewPassword ? "text" : "password"}
            value={newpassword.pass}
            onChange={(e) => {
              setNewpassword({ pass: e.target.value });
              setNewPasswordError(passwordValidation(e.target.value));
            }}
            onBlur={(e) => {
              setNewPasswordError(passwordValidation(newpassword.pass));
            }}
            error={!!newPasswordError}
            helperText={newPasswordError && newPasswordError}
            FormHelperTextProps={{ style: { fontFamily: "poppins" } }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    style={{ color: "white" }}
                    aria-label="toggle password visibility"
                    onClick={handleClickShowNewPassword}
                    onMouseDown={handleMouseDownNewPassword}
                  >
                    {showNewPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <WhiteBorderTextField
            className="inputField"
            sx={{ input: { color: "white", fontFamily: "poppins" } }}
            label="Re-enter New Password"
            InputLabelProps={{
              style: {
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                width: "100%",
                color: "#808080",
              },
            }}
            variant="outlined"
            type={showReEnteredPassword ? "text" : "password"}
            value={reEnteredPassword.pass}
            onChange={(e) => {
              setReEnteredPassword({ pass: e.target.value });
              e.target.value === newpassword.pass
                ? setReEnteredPasswordError("")
                : setReEnteredPasswordError("Password does not match");
            }}
            onBlur={(e) => {
              reEnteredPassword.pass === newpassword.pass
                ? setReEnteredPasswordError("")
                : setReEnteredPasswordError("Password does not match");
            }}
            error={!!reEnteredPasswordError}
            helperText={reEnteredPasswordError && reEnteredPasswordError}
            FormHelperTextProps={{ style: { fontFamily: "poppins" } }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    style={{ color: "white" }}
                    aria-label="toggle password visibility"
                    onClick={handleClickShowReEnteredPassword}
                    onMouseDown={handleMouseDownReEnteredPassword}
                  >
                    {showReEnteredPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Button
            className="loginButton"
            disabled={
              passwordValidation(newpassword.pass) !== "" ||
              (reEnteredPassword.pass !== newpassword.pass &&
                newpassword.pass !== "")
            }
            onClick={() => {
              handleResetPassword();
            }}
          >
            Change Password
          </Button>
        </div>
      </Container>
      <BasicModal open={openErrorModal} handleClose={handleCloseErrorModal}>
        <div className="modalHeaderText">Oppssss...</div>
        <div className="modalSubText">
          {passwordError
            ? passwordError
            : "Review the old and new password fields and Make Another Attempt"}
        </div>
        <Button
          className="modalButton"
          onClick={() => {
            handleCloseErrorModal();
          }}
        >
          Try Again
        </Button>
      </BasicModal>
      <BasicModal open={openSuccessModal} handleClose={handleCloseSuccessModal}>
        <div className="modalHeaderText">Great job!</div>
        <div className="modalSubText">
          You password has been reset. <br /> Unleash the power of song
          requests, AGAIN!
        </div>
        <Button
          className="modalButton"
          onClick={() => {
            // logOutUser();
            handleCloseSuccessModal();
          }}
        >
          Sign In
        </Button>
      </BasicModal>
    </Fragment>
  );
}

export default ChangePassword;
